module.exports = __webpack_public_path__ + "src/assets/img/page10/c93ebafeca20f16b5e0c638d11a87dc6.svg";